import { AxiosRequestConfig } from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { getPublicAxios } from './publicAxios';
import { UseGetResponse } from './useGet';

/**
 * `useGet` for anonymous (`/public/...`) endpoints: identical signature and `{ Data }` envelope, but
 * routed through the interceptor-free instance in `publicAxios`.
 */
export const usePublicGet = <T>(
  url: string,
  axiosCfg: AxiosRequestConfig = {},
  queryOptions: UseQueryOptions<UseGetResponse<T>, Error> = {}
): UsePublicGetResult<T> => {
  const { queryKey = [], ...restQueryOptions } = queryOptions;
  const getResult = useQuery<UseGetResponse<T>, Error>({
    queryKey: [url, ...queryKey],

    queryFn: async () => {
      const axiosRes = await getPublicAxios().request<UseGetResponse<T>>({ url, method: 'GET', ...axiosCfg });
      return axiosRes.data;
    },

    retry: false,
    ...restQueryOptions,
  });

  return getResult;
};

export type UsePublicGetResult<T> = UseQueryResult<UseGetResponse<T>, Error>;
